module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_11.1d424a8c.png";